(($, Drupal) => {
  Drupal.behaviors.clearCookies = {
    attach() {
      $(once('clear-cookies-behavior', '.clear-cookies-button')).each((index, element) => {
        this.attachTrigger(element);
      });
    },
    attachTrigger(element) {
      const trigger = $(element);

      trigger.on('click', (event) => {
        event.preventDefault();
        Drupal.eu_cookie_compliance.setStatus(null);
        Drupal.eu_cookie_compliance.setAcceptedCategories([]);
        window.location.reload();
      });
    },
  };
})(jQuery, Drupal);
